module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('ed-modal', {
    attrs: {
      "title": (_vm.formData.item ? _vm.formData.item._nome + ' :: LOGS' : ''),
      "modal": _vm.showLogs,
      "isModal": false,
      "width": "97%"
    }
  }, [_c('div', {
    attrs: {
      "slot": "modal-content"
    },
    slot: "modal-content"
  }, [_c('el-tabs', {
    attrs: {
      "type": "card"
    },
    model: {
      value: (_vm.tabSelected),
      callback: function($$v) {
        _vm.tabSelected = $$v
      },
      expression: "tabSelected"
    }
  }, [(_vm.formData.item && _vm.formData.item && _vm.formData.item.log_erro.length) ? _c('el-tab-pane', {
    attrs: {
      "label": "Erro",
      "name": "error"
    }
  }, [_c('span', {
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_c('i', {
    staticClass: "fa fa-times-circle"
  }), _vm._v(" Erro\n                  "), (_vm.formData.item && _vm.formData.item.log_erro) ? _c('span', [_vm._v(" (" + _vm._s(_vm.formData.item.log_erro.length) + ")")]) : _vm._e()]), _vm._v(" "), _c('table', {
    staticClass: "table"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Descrição")])])]), _vm._v(" "), _c('tbody', [(!_vm.formData.item || !_vm.formData.item.log_erro || _vm.formData.item.log_erro.length == 0) ? _c('tr', [_c('td', {
    attrs: {
      "align": "center"
    }
  }, [_vm._v("\n                        Nenhum erro encontrado\n                      ")])]) : _vm._l((_vm.formData.item.log_erro), function(item, key) {
    return _c('tr', {
      key: key
    }, [_c('td', {
      staticStyle: {
        "color": "red"
      },
      attrs: {
        "align": "left"
      }
    }, [(item['risco_vinculo']) ? _c('span', [_c('p', {
      staticStyle: {
        "color": "#666"
      }
    }, [_c('b', [_vm._v("RISCO SEM VÍNCULO COM ESOCIAL")])]), _vm._v(" "), _c('p', {
      staticStyle: {
        "color": "#666",
        "font-size": "9pt"
      }
    }, [_c('i', [_vm._v("Acesse o menú Configurações > Riscos para atualizar corretamente os riscos abaixo.")])]), _vm._v(" "), _vm._l((item['risco_vinculo']), function(risco, i) {
      return _c('p', {
        key: i,
        staticStyle: {
          "padding-left": "15px"
        }
      }, [_vm._v("\n                                  " + _vm._s(risco) + "\n                              ")])
    })], 2) : (item['exame_vinculo']) ? _c('span', [_c('p', {
      staticStyle: {
        "color": "#666"
      }
    }, [_c('b', [_vm._v("EXAME SEM VÍNCULO COM ESOCIAL OU COM PROBLEMA DE CADASTRO")])]), _vm._v(" "), _c('p', {
      staticStyle: {
        "color": "#666",
        "font-size": "9pt"
      }
    }, [_c('i', [_vm._v("Acesse o menú Configurações > Exames para atualizar corretamente os exames abaixo.")])]), _vm._v(" "), _vm._l((item['exame_vinculo']), function(exame, i) {
      return _c('p', {
        key: i,
        staticStyle: {
          "padding-left": "15px"
        }
      }, [_vm._v("\n                                  " + _vm._s(exame) + "\n                              ")])
    })], 2) : (item['cadastro_medico']) ? _c('span', [_c('p', {
      staticStyle: {
        "color": "#666"
      }
    }, [_c('b', [_vm._v("CADASTRO DO MÉDICO EXAMINADOR INVÁLIDO")])]), _vm._v(" "), _c('p', {
      staticStyle: {
        "color": "#666",
        "font-size": "9pt"
      }
    }, [_c('i', [_vm._v("Acesse o menú Configurações > Médicos Examinadores para atualizar corretamente o médico da consulta.")])]), _vm._v(" "), _vm._l((item['cadastro_medico']), function(exame, i) {
      return _c('p', {
        key: i,
        staticStyle: {
          "padding-left": "15px"
        }
      }, [_vm._v("\n                                " + _vm._s(exame) + "\n                              ")])
    })], 2) : (item['cadastro_funcionario']) ? _c('span', [_c('p', {
      staticStyle: {
        "color": "#666"
      }
    }, [_c('b', [_vm._v("CADASTRO DO TRABALHADOR INVÁLIDO")])]), _vm._v(" "), _c('p', {
      staticStyle: {
        "color": "#666",
        "font-size": "9pt"
      }
    }, [_c('i', [_vm._v("Acesse o menú Empresa > Funcionários para atualizar corretamente os dados do trabalhador.")])]), _vm._v(" "), _vm._l((item['cadastro_funcionario']), function(risco, i) {
      return _c('p', {
        key: i,
        staticStyle: {
          "padding-left": "15px"
        }
      }, [_vm._v("\n                                  " + _vm._s(risco) + "\n                              ")])
    })], 2) : (item['cadastro_reg_amb']) ? _c('span', [_c('p', {
      staticStyle: {
        "color": "#666"
      }
    }, [_c('b', [_vm._v("CADASTRO RESPONSÁVEL TÉCNICO INVÁLIDO")])]), _vm._v(" "), _c('p', {
      staticStyle: {
        "color": "#666",
        "font-size": "9pt"
      }
    }, [_c('i', [_vm._v("Acesse o menú PPRA/PGR > Gerenciar para atualizar corretamente os dados do responsável pelo PGR.")])]), _vm._v(" "), _vm._l((item['cadastro_reg_amb']), function(posicoes, i) {
      return _c('p', {
        key: i,
        staticStyle: {
          "padding-left": "15px"
        }
      }, [(posicoes.posicao) ? _c('b', [_vm._v(_vm._s(posicoes.posicao) + ":")]) : _vm._e(), _vm._v(" "), (posicoes.msg) ? _c('span', [_vm._v(_vm._s(posicoes.msg))]) : _c('span', [_vm._v(_vm._s(posicoes))])])
    })], 2) : (item['cadastro_ppp_fdt']) ? _c('span', [_c('p', {
      staticStyle: {
        "color": "#666"
      }
    }, [_c('b', [_vm._v("CADASTRO DA EXPOSIÇÃO A FATORES DE RISCOS INVÁLIDO")])]), _vm._v(" "), _c('p', {
      staticStyle: {
        "color": "#666",
        "font-size": "9pt"
      }
    }, [_c('i', [_vm._v("Acesse o menú LTCAT > Gerenciar para atualizar corretamente as medições do LTCAT desse trabalhador.")])]), _vm._v(" "), _vm._l((item['cadastro_ppp_fdt']), function(posicoes, i) {
      return _c('p', {
        key: i,
        staticStyle: {
          "padding-left": "15px"
        }
      }, [(posicoes.msg) ? _c('span', [_vm._v(_vm._s(posicoes.msg))]) : _c('span', [_vm._v(_vm._s(posicoes))])])
    })], 2) : (item['erro_cadastro_fdt']) ? _c('span', [_c('p', {
      staticStyle: {
        "color": "#666"
      }
    }, [_c('b', [_vm._v("CADASTRO DA FRENTE DE TRABALHO INVÁLIDO")])]), _vm._v(" "), _c('p', {
      staticStyle: {
        "color": "#666",
        "font-size": "9pt"
      }
    }, [_c('i', [_vm._v("Acesse o menú Empresa > Editar > Frente de Trabalho > Editar para atualizar corretamente a frente de trabalho.")])]), _vm._v(" "), _vm._l((item['erro_cadastro_fdt']), function(risco, i) {
      return _c('p', {
        key: i,
        staticStyle: {
          "padding-left": "15px"
        }
      }, [_vm._v("\n                                  " + _vm._s(risco) + "\n                              ")])
    })], 2) : (item['cadastro_sem_risco']) ? _c('span', [_c('p', {
      staticStyle: {
        "color": "#666"
      }
    }, [_c('b', [_vm._v("NENHUM RISCO FOI ENCONTRADO")])]), _vm._v(" "), _c('p', {
      staticStyle: {
        "color": "#666",
        "font-size": "9pt"
      }
    }, [_c('i', [_vm._v("Acesse o menú PCMSO > Gerenciar para atualizar corretamente o documento PPRA ou PCMSO.")])]), _vm._v(" "), _vm._l((item['cadastro_sem_risco']), function(risco, i) {
      return _c('p', {
        key: i,
        staticStyle: {
          "padding-left": "15px"
        }
      }, [_vm._v("\n                                  " + _vm._s(risco) + "\n                              ")])
    })], 2) : (item['error_cadastro_epi']) ? _c('span', [_c('p', {
      staticStyle: {
        "color": "#666"
      }
    }, [_c('b', [_vm._v("EPI CADASTRADO INCORRETAMENTE")])]), _vm._v(" "), _c('p', {
      staticStyle: {
        "color": "#666",
        "font-size": "9pt"
      }
    }, [_c('i', [_vm._v("Acesse o menú LTCAT > Gerenciar para atualizar corretamente as medições no documento.")])]), _vm._v(" "), _vm._l((item['error_cadastro_epi']), function(epis, i) {
      return [_c('p', {
        key: i,
        staticStyle: {
          "color": "#000000"
        }
      }, [_c('b', [_vm._v(_vm._s(i))])]), _vm._v(" "), _vm._l((epis), function(epi) {
        return _c('p', {
          key: epi
        }, [_vm._v("\n                                    " + _vm._s(epi) + "\n                                  ")])
      })]
    })], 2) : (item['cadastro']) ? _c('span', [_c('p', {
      staticStyle: {
        "color": "#666"
      }
    }, [_c('b', [_vm._v("CADASTRO INVÁLIDO")])]), _vm._v(" "), _vm._l((item['cadastro']), function(risco, i) {
      return _c('p', {
        key: i,
        staticStyle: {
          "padding-left": "15px"
        }
      }, [_vm._v("\n                                  " + _vm._s(risco) + "\n                              ")])
    })], 2) : (item['cadastro_abs']) ? _c('span', [_c('p', {
      staticStyle: {
        "color": "#666"
      }
    }, [_c('b', [_vm._v("CADASTRO DO ABSENTEÍSMO INVÁLIDO")])]), _vm._v(" "), _c('p', {
      staticStyle: {
        "color": "#666",
        "font-size": "9pt"
      }
    }, [_c('i', [_vm._v("Acesse o menú Absenteísmo > Gerenciar para atualizar corretamente o registro que está com erro")])]), _vm._v(" "), _vm._l((item['cadastro_abs']), function(risco, i) {
      return _c('p', {
        key: i,
        staticStyle: {
          "padding-left": "15px"
        }
      }, [_vm._v("\n                                  " + _vm._s(risco) + "\n                              ")])
    })], 2) : (item['erro_cadastro_setor']) ? _c('span', [_c('p', {
      staticStyle: {
        "color": "#666"
      }
    }, [_c('b', [_vm._v("CADASTRO DO GHE (SETOR) INCORRETO")])]), _vm._v(" "), _c('p', {
      staticStyle: {
        "color": "#666",
        "font-size": "9pt"
      }
    }, [_c('i', [_vm._v("Acesse o menú PPRA/PGR > Gerenciar para atualizar corretamente o GHE (Setor) em questão")])]), _vm._v(" "), _vm._l((item['erro_cadastro_setor']), function(risco, i) {
      return _c('p', {
        key: i,
        staticStyle: {
          "padding-left": "15px"
        }
      }, [_vm._v("\n                                  " + _vm._s(risco) + "\n                              ")])
    })], 2) : (item['erro_cadastro_atividade_funcao']) ? _c('span', [_c('p', {
      staticStyle: {
        "color": "#666"
      }
    }, [_c('b', [_vm._v("DESCRIÇÃO DE ATIVIDADES DA FUNÇÃO NÃO INFORMADA")])]), _vm._v(" "), _c('p', {
      staticStyle: {
        "color": "#666",
        "font-size": "9pt"
      }
    }, [_c('i', [_vm._v("Acesse o menú PPRA/PGR > Gerenciar, selecione o GHE (Setor) indicado e preencha a descrição de atividades da função do trabalhador")])]), _vm._v(" "), _vm._l((item['erro_cadastro_atividade_funcao']), function(risco, i) {
      return _c('p', {
        key: i,
        staticStyle: {
          "padding-left": "15px"
        }
      }, [_vm._v("\n                                  " + _vm._s(risco) + "\n                              ")])
    })], 2) : (item['erro_cadastro_fator_risco']) ? _c('span', [_c('p', {
      staticStyle: {
        "color": "#666"
      }
    }, [_c('b', [_vm._v("FATOR DE RISCO SEM DESCRIÇÃO DA METODOLOGIA")])]), _vm._v(" "), _c('p', {
      staticStyle: {
        "color": "#666",
        "font-size": "9pt"
      }
    }, [_c('i', [_vm._v("Acesse o menú Configurações > Fatores de Risco para preencher a descrição da metodologia do fator de risco indicado")])]), _vm._v(" "), _vm._l((item['erro_cadastro_fator_risco']), function(risco, i) {
      return _c('p', {
        key: i,
        staticStyle: {
          "padding-left": "15px"
        }
      }, [_vm._v("\n                                  " + _vm._s(risco.msg ? risco.msg : risco) + "\n                              ")])
    })], 2) : (item['erro_cadastro_epi_risco']) ? _c('span', [_c('p', {
      staticStyle: {
        "color": "#666"
      }
    }, [_c('b', [_vm._v("EPI NÃO CADASTRADO PARA O RISCO")])]), _vm._v(" "), _c('p', {
      staticStyle: {
        "color": "#666",
        "font-size": "9pt"
      }
    }, [_c('i', [_vm._v("Acesse o menú PPRA/PGR > Gerenciar, selecione o GHE (Setor) e vincule um ou mais EPIs ao risco indicado")])]), _vm._v(" "), _vm._l((item['erro_cadastro_epi_risco']), function(risco, i) {
      return _c('p', {
        key: i,
        staticStyle: {
          "padding-left": "15px"
        }
      }, [_vm._v("\n                                  " + _vm._s(risco.msg ? risco.msg : risco) + "\n                              ")])
    })], 2) : (item['erro_cadastro_reg_amb']) ? _c('span', [_c('p', {
      staticStyle: {
        "color": "#666"
      }
    }, [_c('b', [_vm._v("NENHUMA MEDICAÇÃO FOI CADASTRADO PARA ESSE LTCAT")])]), _vm._v(" "), _c('p', {
      staticStyle: {
        "color": "#666",
        "font-size": "9pt"
      }
    }, [_c('i', [_vm._v("Acesse o menú Ltcat > Gerenciar para atualizar corretamente as medições do GHE (Setor) do funcionário em questão.")])])]) : _c('span', [_c('p', [_vm._v(_vm._s(item))])])])])
  })], 2)])]) : _vm._e(), _vm._v(" "), (_vm.formData.item && _vm.formData.item && _vm.formData.item.log_warning.length) ? _c('el-tab-pane', {
    attrs: {
      "label": "Pontos de Atenção",
      "name": "warning"
    }
  }, [_c('span', {
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_c('i', {
    staticClass: "fa fa-exclamation-circle"
  }), _vm._v(" Pontos de Atenção\n                  "), (_vm.formData.item && _vm.formData.item.log_warning) ? _c('span', [_vm._v(" (" + _vm._s(_vm.formData.item.log_warning.length) + ")")]) : _vm._e()]), _vm._v(" "), _c('table', {
    staticClass: "table"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Descrição")])])]), _vm._v(" "), _c('tbody', [(!_vm.formData.item || !_vm.formData.item.log_warning || _vm.formData.item.log_warning.length == 0) ? _c('tr', [_c('td', {
    attrs: {
      "align": "center"
    }
  }, [_vm._v("\n                        Nenhum ponto de atenção encontrado\n                      ")])]) : _vm._l((_vm.formData.item.log_warning), function(item, key) {
    return _c('tr', {
      key: key
    }, [_c('td', {
      staticStyle: {
        "color": "#ff8300"
      },
      attrs: {
        "align": "left"
      }
    }, [_c('span', [_c('p', {
      domProps: {
        "innerHTML": _vm._s(item)
      }
    })])])])
  })], 2)])]) : _vm._e()], 1)], 1)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-b3fd2992"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/apps/web/esocial/includes/logs.vue
// module id = 1572
// module chunks = 45